import React, { Component } from 'react';
import { Form, Input, Modal, Button, Icon, Header } from 'semantic-ui-react';
import ToastUtilities from './ToastUtilities';
import AuthService from '../services/Auth';
let authService = new AuthService();

const LOGIN_INITIAL_STATE = {
    email: '',
    password: '',
    loading: false,
};

export default class Login extends Component {
    constructor(props) {
        super(props);

        this.state = { ...LOGIN_INITIAL_STATE };
    }

    componentDidUpdate(prevProps) {
        if (prevProps !== this.props) {
            this.setState({ ...LOGIN_INITIAL_STATE });
        }
    }

    handleChange = (e) => {
        this.setState({ [e.target.name]: e.target.value });
    }

    handleSubmit = (e) => {
        e.preventDefault();
        this.setState({ loading: true });
        const { email, password } = this.state;
        authService.logIn(email, password)
            .then((response) => {
                this.setState({ loading: false });
                if (!response.isError) {
                    window.location.reload();
                } else {
                    ToastUtilities.error(response.errorContent.errorMessage);
                }
            })
    }

    render() {
        const { email, password, loading } = this.state;
        const invalid = email === '' || password === '' || loading;

        return (
            <Modal
                open={this.props.modalOpen}
                size='small'
                closeIcon
                closeOnEscape={true}
                closeOnDimmerClick={false}
                onClose={this.props.handleClose}
            >
                <Header icon='user' content='Log In' />
                <Modal.Content>
                    <Form onSubmit={this.handleSubmit}>
                        <Form.Field>
                            <label>Email:</label>
                            <Input
                                name='email'
                                placeholder='Email'
                                value={email}
                                onChange={this.handleChange}
                            />
                        </Form.Field>
                        <Form.Field>
                            <label>Password:</label>
                            <Input
                                name='password'
                                placeholder='Password'
                                value={password}
                                onChange={this.handleChange}
                                type='password'
                            />
                        </Form.Field>
                        <Button color='green' type='submit' disabled={invalid} className='auth-button' loading={loading}>
                            <Icon name='user' /> Login
                        </Button>
                        <Button basic onClick={this.props.handleClose} className='auth-button' loading={loading}>
                            <Icon name='remove' /> Close
                        </Button>
                    </Form>
                    <ForgotPassword />
                </Modal.Content>
            </Modal>
        );
    }
}

const FORGOT_PASSWORD_INITIAL_STATE = {
    open: false,
    email: '',
    loading: false,
};

class ForgotPassword extends Component {
    constructor(props) {
        super(props);

        this.state = { ...FORGOT_PASSWORD_INITIAL_STATE };
    }

    open = () => this.setState({ open: true });
    close = () => this.setState({ open: false });

    handleChange = (e) => this.setState({ email: e.target.value });

    handleSubmit = (e) => {
        e.preventDefault();
        this.setState({ loading: true });
        const { email } = this.state;
        authService.forgotPassword(email)
            .then((response) => {
                if (!response.isError) {
                    ToastUtilities.success('Check your email for a new password.');
                    this.setState({ loading: false, open: false });
                } else {
                    ToastUtilities.error(response.errorContent.errorMessage);
                    this.setState({ loading: false });
                }
            });
    }

    handleClose = () => {
        this.setState({ open: false });
    }

    render() {
        const { open, email, loading } = this.state;
        const invalid = email === '';

        return (
            <Modal
                open={open}
                onOpen={this.open}
                onClose={this.close}
                size='small'
                closeOnEscape={true}
                closeOnDimmerClick={false}
                closeIcon
                trigger={
                    <Button style={{ background: 'none', cursor: 'pointer', paddingLeft: '0px', color: 'cornflowerblue'}} variant="link" type="Submit">Forgot Password?</Button>
                    }
                >
                <Modal.Header>Forgot Password</Modal.Header>
                <Modal.Content>
                    <Form onSubmit={this.handleSubmit}>
                        <Form.Field>
                            <label>Enter your email and click send.</label>
                            <Input
                                name='email'
                                placeholder='Email'
                                value={email}
                                onChange={this.handleChange}
                            />
                        </Form.Field>
                        <Button type='submit' basic color='green' icon='check' content='Send' className='auth-button' disabled={invalid} loading={loading} />
                        <Button basic onClick={this.handleClose} className='auth-button' loading={loading}>
                            <Icon name='remove' /> Close
                        </Button>
                    </Form>
                </Modal.Content>
            </Modal>
        );
    }
}